var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { ControlImpl } from './control';
import { ValidationErrorHandler } from './validation-error-handler';
var FormControlImpl = /** @class */ (function (_super) {
    __extends(FormControlImpl, _super);
    function FormControlImpl(key, _parent, _validators) {
        if (_validators === void 0) { _validators = []; }
        var _this = _super.call(this, key) || this;
        _this._parent = _parent;
        _this._validators = _validators;
        return _this;
    }
    Object.defineProperty(FormControlImpl.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormControlImpl.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    FormControlImpl.prototype.setValue = function (value, emit) {
        this._value = value;
        this.emitValue(emit);
        return this;
    };
    FormControlImpl.prototype.validate = function () {
        var e_1, _a;
        var handler = new ValidationErrorHandler();
        try {
            for (var _b = __values(this._validators), _c = _b.next(); !_c.done; _c = _b.next()) {
                var validator = _c.value;
                var result = validator(this);
                handler.addErrors(result);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this._errors = handler.getErrors();
        this._valid = handler.isValid();
        this.emitValidationState();
        return this.errors;
    };
    return FormControlImpl;
}(ControlImpl));
export { FormControlImpl };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybS1jb250cm9sLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vbGliL2Zvcm0tY29udHJvbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEVBQVcsV0FBVyxFQUFFLE1BQU0sV0FBVyxDQUFBO0FBQ2hELE9BQU8sRUFBRSxzQkFBc0IsRUFBRSxNQUFNLDRCQUE0QixDQUFBO0FBUW5FO0lBQXdDLG1DQUFjO0lBU3BELHlCQUNFLEdBQVcsRUFDSCxPQUF1QixFQUN2QixXQUFnQztRQUFoQyw0QkFBQSxFQUFBLGdCQUFnQztRQUgxQyxZQUtFLGtCQUFNLEdBQUcsQ0FBQyxTQUNYO1FBSlMsYUFBTyxHQUFQLE9BQU8sQ0FBZ0I7UUFDdkIsaUJBQVcsR0FBWCxXQUFXLENBQXFCOztJQUcxQyxDQUFDO0lBZEQsc0JBQUksbUNBQU07YUFBVjtZQUNFLE9BQU8sSUFBSSxDQUFDLE9BQU8sQ0FBQTtRQUNyQixDQUFDOzs7T0FBQTtJQUVELHNCQUFJLGtDQUFLO2FBQVQ7WUFDRSxPQUFPLElBQUksQ0FBQyxNQUFNLENBQUE7UUFDcEIsQ0FBQzs7O09BQUE7SUFVTSxrQ0FBUSxHQUFmLFVBQWdCLEtBQWUsRUFBRSxJQUFjO1FBQzdDLElBQUksQ0FBQyxNQUFNLEdBQUcsS0FBSyxDQUFBO1FBRW5CLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUE7UUFFcEIsT0FBTyxJQUFJLENBQUE7SUFDYixDQUFDO0lBRU0sa0NBQVEsR0FBZjs7UUFDRSxJQUFNLE9BQU8sR0FBRyxJQUFJLHNCQUFzQixFQUFFLENBQUE7O1lBRTVDLEtBQXdCLElBQUEsS0FBQSxTQUFBLElBQUksQ0FBQyxXQUFXLENBQUEsZ0JBQUEsNEJBQUU7Z0JBQXJDLElBQU0sU0FBUyxXQUFBO2dCQUNsQixJQUFNLE1BQU0sR0FBRyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUE7Z0JBRTlCLE9BQU8sQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLENBQUE7YUFDMUI7Ozs7Ozs7OztRQUVELElBQUksQ0FBQyxPQUFPLEdBQUcsT0FBTyxDQUFDLFNBQVMsRUFBRSxDQUFBO1FBQ2xDLElBQUksQ0FBQyxNQUFNLEdBQUcsT0FBTyxDQUFDLE9BQU8sRUFBRSxDQUFBO1FBRS9CLElBQUksQ0FBQyxtQkFBbUIsRUFBRSxDQUFBO1FBRTFCLE9BQU8sSUFBSSxDQUFDLE1BQU0sQ0FBQTtJQUNwQixDQUFDO0lBQ0gsc0JBQUM7QUFBRCxDQUFDLEFBekNELENBQXdDLFdBQVcsR0F5Q2xEIn0=